// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1713 ? "sales" : chunkId) + "." + {"511":"5604cd35","525":"d8e7856e","1713":"b61a84e5","2050":"65532cff","2785":"227fcf27","3983":"f7312005","6020":"baff4989","6882":"2ba253e5","8583":"c69abe42","8948":"badfce17","9718":"c4c88b3e","9797":"42443cb0"}[chunkId] + ".css";
};